export interface AccountManagerDTO {
  active       : boolean;
  contactNumber: string;
  email        : string;
  enteredBy    : number;
  enteredDate? : any;
  hasPhoto     : boolean;
  id           : number;
  name         : string;
  photoUrl?    : string;
  systemOwned  : boolean;
};

export function AccountManagerDTO_EmptyObject(): AccountManagerDTO {
  return {
    active       : true,
    contactNumber: "",
    email        : "",
    enteredBy    : 0,
    hasPhoto     : false,
    id           : 0,
    name         : "",
    systemOwned  : false
  };
};
